export class LossRangesData {
    id: number;
    name: string;
    minValue: number;
    maxValue: number;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/lossRangesData.ts